"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "jss", {
  enumerable: true,
  get: function get() {
    return _reactJss.jss;
  }
});
Object.defineProperty(exports, "JssProvider", {
  enumerable: true,
  get: function get() {
    return _reactJss.JssProvider;
  }
});
Object.defineProperty(exports, "makeTheme", {
  enumerable: true,
  get: function get() {
    return _styleMap.createStyleMap;
  }
});
exports.createUseStyles = exports.theming = exports.useTheme = exports.withTheme = exports.withStyles = exports.ThemeProvider = exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireWildcard(require("react-jss"));

var _jssVendorPrefixerIe = _interopRequireDefault(require("jss-vendor-prefixer-ie10"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _styleMap = require("./styleMap");

require("../../v2/theme/sheet");

var _index = _interopRequireDefault(require("./theme/index.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

_reactJss.jss.use((0, _jssVendorPrefixerIe["default"])()); // Creating a namespaced theming object.


var ThemeContext = React.createContext(_index["default"]); // $FlowIgnore

var theming = (0, _reactJss.createTheming)(ThemeContext);
exports.theming = theming;
var ThemeProvider = theming.ThemeProvider,
    useTheme = theming.useTheme;
exports.useTheme = useTheme;
exports.ThemeProvider = exports["default"] = ThemeProvider;

var withStyles = function withStyles(makeStyles) {
  return function (Component) {
    // $FlowIgnore
    return (0, _reactJss["default"])(makeStyles, {
      inject: ['classes'],
      theming: theming
    })(Component);
  };
};

exports.withStyles = withStyles;

var withTheme = function withTheme(theme) {
  return function (Component) {
    var WithTheme = /*#__PURE__*/function (_React$Component) {
      (0, _inherits2["default"])(WithTheme, _React$Component);

      var _super = _createSuper(WithTheme);

      function WithTheme() {
        (0, _classCallCheck2["default"])(this, WithTheme);
        return _super.apply(this, arguments);
      }

      (0, _createClass2["default"])(WithTheme, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(ThemeProvider, {
            theme: theme
          }, /*#__PURE__*/React.createElement(Component, this.props));
        }
      }]);
      return WithTheme;
    }(React.Component);

    return (0, _hoistNonReactStatics["default"])(WithTheme, Component);
  };
};

exports.withTheme = withTheme;

var createUseStyles = function createUseStyles(styles) {
  return (0, _reactJss.createUseStyles)(styles, {
    theming: theming
  });
};

exports.createUseStyles = createUseStyles;
//# sourceMappingURL=index.js.map